module.exports = __webpack_public_path__ + "static/media/Angela Casarez.7d2e800f.png";